import _ from "lodash";
import Colors from "../../styles/colors";
import GeofenceType, { getType } from "./geofence-types";

const { fillColor, strokeColor } = Colors.geofence;

export const geofenceShapesForLocation = (location, H) => {
  const { geofence } = location;
  if (!geofence) {
    return [];
  }

  const fencetype = getType(geofence);
  if (fencetype === GeofenceType.RADIAL) {
    if (geofence.geometry.coordinates.length > 0) {
      const [lng, lat] = geofence.geometry.coordinates;
      const radiusMeters = _.max([geofence.properties.buffer, 0.1]);
      const geofenceCircle = new H.map.Circle({ lat, lng }, radiusMeters, {
        style: { fillColor, strokeColor }
      });
      return [geofenceCircle];
    }
  } else if (fencetype === GeofenceType.POLYGONAL) {
    // List of points are LAT, LONG, ALT
    var pointList = [];
    geofence.geometry.coordinates[0].forEach(c => {
      pointList.push(c[1]);
      pointList.push(c[0]);
      pointList.push(100);
    });

    const lineString = new H.geo.LineString(pointList, "values lat lng alt");
    const geofencePoly = new H.map.Polygon(lineString, {
      style: { fillColor, strokeColor }
    });
    return [geofencePoly];
  }

  return [];
};



// WEBPACK FOOTER //
// ./src/modules/geofence-edit/geofence-map-shapes.js